<template>
  <div class="container section">
    <back-navigation :redirect="{ name: 'resources' }" />
    <skeleton-loading class="column is-6" v-if="isLoading" />
    <div v-else-if="resource" class="columns">
      <div class="column is-one-third resource tw-mt-5">
        <div class="tw-max-w-xs tw-m-auto tw-mb-10">
          <figure v-if="resource.cover" class="image is-2by3">
            <div
              class="bookmark-icon tw-absolute tw-z-20 tw-bg-white"
              v-if="isBookmarked"
            >
              <b-icon type="is-danger" icon="mdi mdi-bookmark"></b-icon>
            </div>
            <img v-lazy="resource.cover.url" />
          </figure>
        </div>
        <div class="tw-text-center">
          <p
            class="is-size-1 tw-text-black tw-font-semibold session-title is-uppercase tw-mt-10"
          >
            {{ resource.title }}
          </p>
          <p class="tw-italic">
            {{ resource.subtitle }}
          </p>
          <b-button
            class="tw-mt-10"
            id="bookmark-toggle"
            :loading="isSubmitting"
            :type="isBookmarked ? `is-warning` : `is-red`"
            @click.prevent="toggleBookmark()"
            >{{
              isBookmarked ? `Unbookmark` : `Bookmark this Resource`
            }}</b-button
          >
        </div>
      </div>
      <div class="column">
        <div class="section-block">
          <span class="title">RESOURCE VIDEOS</span>
        </div>

        <div v-if="resource.videos.length" class="columns is-multiline">
          <div
            v-for="video in resource.videos"
            :key="video.id"
            class="column is-half"
          >
            <router-link
              :to="{
                name: 'resources.course',
                params: { slug: resource.slug, course: video.slug }
              }"
            >
              <course-video :video="video" />
            </router-link>
          </div>
        </div>
        <div v-else>
          <span class="tw-text-gray-300">No videos uploaded yet.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CourseVideo from '@/components/CourseVideo'
import Resource from '@/models/Resource'
import * as ResourceType from '@/utils/consts/ResourceType'
import BackNavigation from '@/components/BackNavigation'

export default {
  components: {
    CourseVideo,
    BackNavigation
  },
  metaInfo() {
    if (this.resource) {
      return {
        title: this.resource.title
      }
    }
  },
  data() {
    return {
      isSubmitting: false,
      isBookmarked: false,
      isLoading: false,
      resource: null
    }
  },
  mounted() {
    if (this.$route.params.slug) {
      this.getResource(this.$route.params.slug)
    }
  },
  methods: {
    getResource(slug) {
      this.isLoading = true
      Resource.include('cover', 'videos.cover')
        .where('type', ResourceType.LTG)
        .$find(slug)
        .then(resource => {
          this.resource = resource
          this.getBookmark()
        })
        .catch(() => {
          this.$router.replace({ name: 'resources' })
        })
        .then(() => {
          this.isLoading = false
        })
    },
    async getBookmark() {
      this.isBookmarked = this.resource.is_bookmarked
    },
    async toggleBookmark() {
      this.isSubmitting = true
      this.isBookmarked ? await this.delBookmark() : await this.saveBookmark()
    },
    async saveBookmark() {
      this.$api
        .post('resources/' + this.resource.id + '/bookmark')
        .then(() => {
          this.isBookmarked = true
          return true
        })
        .catch(({ response }) => {
          if (response.data && response.data.errors) {
            this.showSnackbar(response.data.message, 'is-danger')
          }
          return true
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },
    async delBookmark() {
      this.$api
        .delete('resources/' + this.resource.id + '/bookmark')
        .then(() => {
          this.isBookmarked = false
          return true
        })
        .catch(({ response }) => {
          if (response.data && response.data.errors) {
            this.showSnackbar(response.data.message, 'is-danger')
          }
          return true
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },
    showSnackbar(message, type) {
      this.$buefy.snackbar.open({
        type: type,
        message: message,
        position: 'is-top'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.resource {
  .cover {
    box-shadow: 0 15px 30px 0 rgba(46, 72, 77, 0.3);
  }
}
.bookmark-icon {
  display: inline-block;
  padding: 10px;
  line-height: 0;
  top: -10px;
  left: -13px;
  border-radius: 20px;
}
.is-red {
  color: white;
  background-color: #d10a10;
  border: none;
}
</style>
